import { ProductState } from '../../types/generated';
import { Router, RouteComponentProps } from '@reach/router';
import canUseDOM from '../../utilities/canUseDOM';
import LoaderMask from '../../components/LoaderMask';
import Product from '../../components/Product';

export interface ProductPageProps extends ProductState {}

export default function ProductPage({
  transactionalCurrency,
  product,
  isLoggedIn,
  baseUrl,
  showMoreOptions,
  showSecondaryPrice,
  showProductReviews,
  showDocuments,
  showFeatures,
  showUsefulLinks,
  trustPilotBusinessUnitId,
  website,
  isCssFavouritesEnabled
}: ProductPageProps) {
  if (!product) {
    return null;
    //todo: return an error message
  }

  // const basePath = baseUrl ? baseUrl.replace(/(((\/)+$)|(\?f=.*))/, '') : '/';
  // const basePath = baseUrl ? baseUrl.replace(/\/(?!.*\/).*/, '') : '/';
  const basePath = baseUrl || '/';

  // console.log('basePath', basePath);

  /**
   * Render
   */

  if (!canUseDOM()) {
    return (
      <Product
        fallback={<LoaderMask type="fixed" />}
        path={`${basePath}/:catalogueRefParam`}
        baseUrl={basePath}
        showMoreOptions={showMoreOptions}
        product={product}
        isLoggedIn={isLoggedIn}
        transactionalCurrency={transactionalCurrency}
        showSecondaryPrice={showSecondaryPrice}
        showProductReviews={showProductReviews}
        showDocuments={showDocuments}
        showFeatures={showFeatures}
        showUsefulLinks={showUsefulLinks}
        trustPilotBusinessUnitId={trustPilotBusinessUnitId}
        quantity={product.baseQuantity}
        website={website}
        isCssFavouritesEnabled={isCssFavouritesEnabled}
      />
    );
  }

  return (
    <Router basepath={basePath || '/'}>
      <Product
        path={`/:catalogueRefParam`}
        baseUrl={basePath}
        showMoreOptions={showMoreOptions}
        product={product}
        isLoggedIn={isLoggedIn}
        transactionalCurrency={transactionalCurrency}
        showSecondaryPrice={showSecondaryPrice}
        showProductReviews={showProductReviews}
        showDocuments={showDocuments}
        showFeatures={showFeatures}
        showUsefulLinks={showUsefulLinks}
        trustPilotBusinessUnitId={trustPilotBusinessUnitId}
        quantity={product.baseQuantity}
        website={website}
        isCssFavouritesEnabled={isCssFavouritesEnabled}
      />
      <NotFound default={true} />
    </Router>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NotFound = ({ ...props }: RouteComponentProps) => (
  <div>
    <h3>Not Found</h3>
  </div>
);
